<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ id ? 'Editar Registro' : 'Nuevo Registro' }}
</h2>

<mat-dialog-content class="modal-content">
  <form [formGroup]="form" class="flex flex-col gap-4">

    <app-form-section title="Información General" icon="info" iconColor="blue">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <!-- Código -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Código</mat-label>
          <input matInput formControlName="code" name="code" [readonly]="id" />
          @if(form.get('code')?.hasError('required') && form.get('code')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>

        <!-- Punto de Emisión -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Punto de Emisión</mat-label>
          <mat-select placeholder="Seleccione un punto de emisión" formControlName="emissionPoint" required>
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchEmissionPoint" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="changeOptionsEmissionPoint($event)" placeholderLabel="Buscar..."
                noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let ep of listFilteremissionPointList" [value]="ep._id">
              {{ ep.name }}
            </mat-option>
          </mat-select>
          <button mat-icon-button matSuffix *ngIf="form.get('emissionPoint')?.value"
            (click)="form.get('emissionPoint')?.setValue('')" type="button">
            <mat-icon>close</mat-icon>
          </button>

          @if(form.get('emissionPoint')?.hasError('required') && form.get('emissionPoint')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>

        <!-- Tipo de Documento -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Tipo de Documento</mat-label>
          <mat-select placeholder="Seleccione un tipo de documento" formControlName="documentType"
            (selectionChange)="onDocumentTypeSelectionChange($event.value)" required>
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchDocumentType" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="changeOptionsDocumentType($event)" placeholderLabel="Buscar..."
                noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let dt of listFilterdocumentTypeList" [value]="dt._id">
              <b>{{ dt.code }}</b> - {{ dt.name }}
            </mat-option>
          </mat-select>

          <button mat-icon-button matSuffix *ngIf="form.get('documentType')?.value"
            (click)="form.get('documentType')?.setValue('')" type="button">
            <mat-icon>close</mat-icon>
          </button>

          @if(form.get('documentType')?.hasError('required') && form.get('documentType')?.touched){
          <mat-error>El campo es requerido</mat-error>
          }
        </mat-form-field>

        <!-- Clase de Documento -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Clase de Documento</mat-label>
          <mat-select placeholder="Seleccione una clase de documento" formControlName="documentClass" required>
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchDocumentClass" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="changeOptionsDocumentClass($event)" placeholderLabel="Buscar..."
                noEntriesFoundLabel="No se encontraron resultados">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let dc of listFilterdocumentClassList" [value]="dc._id">
              <b>{{ dc.code }}</b> - {{ dc.name }}
            </mat-option>
          </mat-select>

          <button mat-icon-button matSuffix *ngIf="form.get('documentClass')?.value"
            (click)="form.get('documentClass')?.setValue('')" type="button">
            <mat-icon>close</mat-icon>
          </button>

          @if(form.get('documentClass')?.hasError('required') && form.get('documentClass')?.touched){
          <mat-error>El campo es requerido</mat-error>
          }
        </mat-form-field>
      </div>
    </app-form-section>

    <!-- Configuración de Rangos -->
    <app-form-section title="Configuración de Rangos" icon="calendar_today" iconColor="green">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Fecha de Inicio -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Fecha de Inicio</mat-label>
          <input matInput [matDatepicker]="pickerStart" formControlName="dateTimeStart" (ngModelChange)="onDateChange()"
            required />
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
          @if(form.get('dateTimeStart')?.hasError('required') && form.get('dateTimeStart')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>

        <!-- Fecha de Fin -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Fecha de Fin</mat-label>
          <input matInput [matDatepicker]="pickerEnd" formControlName="dateTimeEnd" (ngModelChange)="onDateChange()"
            required />
          <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
          @if(form.get('dateTimeEnd')?.hasError('required') && form.get('dateTimeEnd')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>
      </div>
    </app-form-section>

    <!-- Formato de Documentos -->
    <app-form-section title="Formato de Documentos" icon="text_format" iconColor="purple">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

        <!-- Formato Izquierdo -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Formato Izquierdo</mat-label>
          <input matInput formControlName="leftFormat" [maxlength]="getAvailableCharsForSide('left')"
            (ngModelChange)="onFormatChange()" />
          <mat-hint>
            {{ (form.value.leftFormat || '').length }} / {{ getAvailableCharsForSide('left') }} caracteres
          </mat-hint>
          @if(form.get('leftFormat')?.hasError('required') && form.get('leftFormat')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>

        <!-- Formato Derecho -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Formato Derecho</mat-label>
          <input matInput formControlName="rightFormat" [maxlength]="getAvailableCharsForSide('right')"
            (ngModelChange)="onFormatChange()" />
          <mat-hint>
            {{ (form.value.rightFormat || '').length }} / {{ getAvailableCharsForSide('right') }} caracteres
          </mat-hint>
        </mat-form-field>

        <!-- Número de Autorización -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Número de Autorización</mat-label>
          <input matInput formControlName="authorizationNumber" />
        </mat-form-field>
      </div>

      <!-- Ejemplo -->
      <div class="col-span-full">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Ejemplo de formato final</mat-label>
          <input matInput [value]="generateExample()" readonly class="font-mono"
            [class.text-red-500]="!validateExampleLength()" />
          <mat-hint *ngIf="validateExampleLength()" class="text-green-600">
            ✓ {{ generateExample().length }} / {{ getMaxCharacters() || 20 }} permitidos
          </mat-hint>
          <mat-hint *ngIf="!validateExampleLength()" class="text-red-500">
            ❌ Excede el máximo de {{ getMaxCharacters() || 20 }} caracteres
          </mat-hint>
          <mat-error *ngIf="!validateExampleLength()">
            Formato demasiado largo. Ajuste los formatos izquierdo y/o derecho.
          </mat-error>
        </mat-form-field>
      </div>
    </app-form-section>

    <!-- Límites y Valores -->
    <app-form-section title="Límites y Valores" icon="trending_up" iconColor="orange">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
        <mat-form-field appearance="fill">
          <mat-label>Límite Inferior</mat-label>
          <input matInput formControlName="lowerLimit" type="text" mask="separator.0" thousandSeparator=","
            (ngModelChange)="onValueChange()" required />
          @if(form.get('lowerLimit')?.hasError('required') && form.get('lowerLimit')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
          @if(form.get('lowerLimit')?.hasError('pattern') && form.get('lowerLimit')?.touched){
          <mat-error>
            Solo se permiten números
          </mat-error>
          }
          @if(form.get('lowerLimit')?.errors?.min){
          <mat-error>
            El valor debe ser mayor que 0
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Límite Superior</mat-label>
          <input matInput formControlName="upperLimit" type="text" mask="separator.0" thousandSeparator=","
            (ngModelChange)="onValueChange()" required />
          @if(form.get('upperLimit')?.hasError('required') && form.get('upperLimit')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
          @if(form.get('upperLimit')?.hasError('pattern') && form.get('upperLimit')?.touched){
          <mat-error>
            Solo se permiten números
          </mat-error>
          }
          @if(form.get('upperLimit')?.errors?.min){
          <mat-error>
            El valor debe ser mayor que 0
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Valor Inicial</mat-label>
          <input matInput formControlName="initialValue" type="text" mask="separator.0" thousandSeparator=","
            (ngModelChange)="onInitialValue()" required />
          @if(form.get('initialValue')?.hasError('required') && form.get('initialValue')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
          @if(form.get('initialValue')?.hasError('pattern') && form.get('initialValue')?.touched){
          <mat-error>
            Solo se permiten números
          </mat-error>
          }
          @if(form.get('initialValue')?.errors?.min){
          <mat-error>
            El valor debe ser mayor que 0
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Valor Actual</mat-label>
          <input matInput formControlName="currentValue" type="text" mask="separator.0" thousandSeparator="," readonly
            required />
          @if(form.get('currentValue')?.hasError('required') && form.get('currentValue')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
          @if(form.get('currentValue')?.hasError('pattern') && form.get('currentValue')?.touched){
          <mat-error>
            Solo se permiten números
          </mat-error>
          }
        </mat-form-field>
      </div>
    </app-form-section>

    <!--  Notificaciones -->
    <app-form-section title="Notificaciones" icon="notifications" iconColor="indigo">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
        <mat-form-field appearance="fill" class="col-span-2">
          <mat-label>Correo Electrónico</mat-label>
          <input matInput formControlName="email" type="email" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Notificar después de</mat-label>
          <input matInput [matDatepicker]="pickerNotify" formControlName="notifyAfter" (ngModelChange)="onDateChange()"
            required />
          <mat-datepicker-toggle matSuffix [for]="pickerNotify"></mat-datepicker-toggle>
          <mat-datepicker #pickerNotify></mat-datepicker>
          @if(form.get('notifyAfter')?.hasError('required') && form.get('notifyAfter')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Notificar cuando alcance</mat-label>
          <input matInput formControlName="notifyWhenReachNumber" type="text" mask="separator.0" thousandSeparator=","
            (ngModelChange)="onReachValue()" />
          @if(form.get('notifyWhenReachNumber')?.hasError('required') && form.get('notifyWhenReachNumber')?.touched){
          <mat-error>
            El campo es requerido
          </mat-error>
          }
          @if(form.get('notifyWhenReachNumber')?.hasError('pattern') && form.get('notifyWhenReachNumber')?.touched){
          <mat-error>
            Solo se permiten números
          </mat-error>
          }
          @if(form.get('notifyWhenReachNumber')?.errors?.min){
          <mat-error>
            El valor debe ser mayor que 0
          </mat-error>
          }
        </mat-form-field>
      </div>
    </app-form-section>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between p-4">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSave()"
    [disabled]="!form.valid || validFormR || validFormDate || validFormReach || validFormInitial || validFormRange || validFormFormat">
    Guardar
  </button>
</mat-dialog-actions>